const header = document.querySelector("header#header-site");

if (header) {
  let lastScrollY = window.scrollY;

  window.addEventListener(
    "scroll",
    () => {
      const currentScrollY = window.scrollY;
      header.classList.toggle("scrolling", currentScrollY > 50);
      header.classList.toggle(
        "scrolling-hidden",
        currentScrollY > lastScrollY && currentScrollY > 50,
      );
      lastScrollY = currentScrollY;
    },
    { passive: true },
  );

  const menuBtn = header.querySelector("#menu-btn");
  const nav = document.querySelector("#header-site--nav");

  if (menuBtn && nav) {
    menuBtn.innerHTML = `
          <button class="hamburger" aria-label="Toggle navigation" aria-expanded="false">
              <span></span>
              <span></span>
              <span></span>
          </button>
      `;

    const btn = menuBtn.querySelector<HTMLButtonElement>(".hamburger")!;

    btn.addEventListener("click", () => {
      const isOpen = nav.classList.toggle("nav--open");
      btn.setAttribute("aria-expanded", String(isOpen));
      btn.classList.toggle("is-active", isOpen);
    });

    let menuItems = document.querySelectorAll(
      "#header-nav--drawer li.nav-drawer--item",
    );
    menuItems.forEach((item) => {
      let dropdown = item.querySelector(".menu-dropdown");
      if (dropdown) {
        dropdown.addEventListener("click", () => {
          item.classList.toggle("is-active");
        });
      }
    });
  }
}
